module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "froala-editor"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-499f727e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/froala-editor/FroalaEditor.vue
// module id = 658
// module chunks = 1